import React from "react";
import "./Header.scss";
import { ProductCatalogueHeader } from "./ProductCatalogueHeader";
import { useCatalogueHeaderModel } from "./useCatalogueHeaderModel";
import { ProductCatalogueHeaderMobile } from "./ProductCatalogueHeaderMobile";

const ProductCatalogueHeaderWrapper = (props) => {
  const {
    isLoading,
    error,
    data: headerModel,
  } = useCatalogueHeaderModel(props.currentPageId);
  if (isLoading) {
    return null;
  }

  return (
    <div className="header-wrapper">
      <ProductCatalogueHeader headerModel={headerModel} />
      <ProductCatalogueHeaderMobile
        headerModel={headerModel}
        frontPageTitle={props.frontPageTitle}
        frontPageUrl={props.frontPageUrl}
      />
    </div>
  );
};

export default ProductCatalogueHeaderWrapper;
